<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>操作记录列表</b></p>

            <div style="display:inline-block;width: 400px;">
                <el-input placeholder="请输入订单编号/目标" v-model="queryValue" class="input-with-select">

                    <el-select v-model="maker" slot="prepend" placeholder="请选择" @change="selectMaker" style="width:110px">
                        <el-option v-for="item in empList" :key="item.value" :label="item.employeeName"
                            :value="item.userId"></el-option>
                    </el-select>

                    <el-button slot="append" icon="el-icon-search" @click="searchOperation"></el-button>
                </el-input>
            </div>

        </div>

        <el-table :data="operationList" style="width: 100%" ref="plasticTable" highlight-current-row>
            <el-table-column type="index" width="40" fixed>
            </el-table-column>

            <el-table-column prop="maker" label="操作人" min-width="15%">
            </el-table-column>

            <el-table-column prop="createdTime" label="时间" min-width="20%">
            </el-table-column>

            <el-table-column prop="operateTarget" label="目标" min-width="35%">
            </el-table-column>
            <el-table-column prop="operateFunction" label="操作" min-width="15%">
            </el-table-column>
            <el-table-column prop="operateModule" label="模块" min-width="15%">
            </el-table-column>

            <!-- <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        更改
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column> -->
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes, prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

    </div>
</template>

<script>
export default {
    name: "OperationRecord",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            operationList: [],

            empList: [],
            maker: '',

            queryValue: '',
            loading: false,
            formLabelWidth: '120px',

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        searchOperation(query) {
            
            this.pageIndex = 0

            if (this.queryValue !== '') {

                this.loading = true
                
                setTimeout(() => {
                    this.loading = false

                    this.getAll()
                }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        getAllEmp() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll",
                data: {
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.empList = data.data
            })
        },
        selectMaker() {

            this.getAll()
        },
        getAll() {

            this.$axios({
                method: "post",
                url: "/shiro/operate/record/getAll",
                data: {
                    maker: this.maker,
                    queryParam: this.queryValue,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.operationList = data.data
                this.total = this.operationList[0].total
                for (let i in this.operationList) {
                    this.operationList[i].createdTime = this.$moment(this.operationList[i].createdTime).format("YYYY-MM-DD HH:mm")
                }
            })
        },
        pageClick(currentPage) {
            this.operationList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll()
        },
    },
    mounted() {
        this.setDefaultPath('/operationRecord')

        this.getAll()

        this.getAllEmp()
    }
}
</script>

<style>
.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}
</style>